<template>
  <div class="chargers">
    <div class="search-box">
      <input v-model="searchQuery" type="search" :placeholder="$t('labels.search').toUpperCase()">
      <span>
        <icon-search/>
      </span>
    </div>
    <h1>{{ $t('nav.chargers') }}</h1>
    <data-table
      :headings="headings"
      :rows="chargers"
      :lazy-load="true"
      :search-query="searchQuery"
    />
    <back-to-top/>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import BackToTop from '@/components/BackToTop.vue'
import { mapGetters } from 'vuex'
import { GET_CHARGERS } from '@/store/actions.type'
import IconSearch from '@/assets/images/icons/search_icon.svg'

export default {
  name: 'chargers',
  components: {
    DataTable,
    BackToTop,
    IconSearch
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  computed: {
    ...mapGetters({
      chargers: ['chargers']
    }),
    headings() {
      return [
        {
          label: this.$t('charger.screenID'),
          key: 'evseDisplayId',
          defaultSort: true
        },
        {
          label: this.$t('tags.stationId'),
          key: 'evseId',
          sortType: 'number'
        },
        {
          label: this.$t('charger.city'),
          key: 'city'
        },
        {
          label: this.$t('tags.state'),
          key: 'stateCode'
        },
        {
          label: this.$t('tags.zip'),
          key: 'zipCode',
          sortType: 'number'
        },
        {
          label: this.$t('tags.sitehost'),
          key: 'locationName'
        },
        // {
        //   label: 'Utility'
        //   // key: 'evseDisplayId'
        // },
        {
          label: this.$t('charger.screensInUse'),
          key: 'screenInUse'
        }
      ]
    }
  },
  created() {
    const loader = this.$loading.show()
    this.$store.dispatch(GET_CHARGERS).finally(() => {
      loader.hide()
    })
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  align-items: flex-end;
  float: right;
  width: 100%;
  max-width: 400px;

  span {
    display: inline-block;
    margin-bottom: em(7);
    max-width: 20px;
    max-height: 20px;

    svg {
      fill: currentColor;
    }
  }
}
</style>
